exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dialog-form-div[data-v-6605d351] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 20px;\n}\n[data-v-6605d351] .el-form-item__error {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex\n}\n", ""]);

// exports
